bovoApp.
factory('Stock', ['$http', function($http) {
    return {
      all: function(data) {
        return $http.post('api/stock-products',data);
      },
      get: function(id) {
        return $http.get('api/stock-product/' + id);
      },
      new: function(id) {
        return $http.get('api/new-stock-product');
      },
      delete: function(id) {
        return $http.delete('api/delete-stock-product/' + id);
      },
      save: function(data) {
        return $http.post('api/save-stock-product',data);
      },
      update: function(data) {
        return $http.post('api/update-stock-product',data);
      }
    };
}]);